import { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { useSearchParams, useNavigate } from 'react-router-dom';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import api from '../../api/axiosInstance';
import { showError, showSuccess } from '../../components/notifications';
import LayoutNoAuth from './layout';

export default function Confirmemail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [stage, setStage] = useState<'idle' | 'confirming' | 'noCode'>('idle');

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setStage('noCode');
      return;
    }

    setStage('confirming');
    (async () => {
      try {
        await api.post('/auth/confirmemail', { code });
        showSuccess('Email успешно подтвержден');
        navigate('/login?confirmed=1', { replace: true });
      } catch (err: any) {
        const message = err.response?.data?.message || err.message || 'Ошибка подтверждения почты';
        showError(message);
        navigate('/login', { replace: true });
      }
    })();
  }, [searchParams, navigate]);

  return (
    <LayoutNoAuth>
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          p: { xs: 2.5, sm: 3 },
          border: '1px solid rgba(0,0,0,0.08)',
          borderRadius: 2,
          boxShadow: '0 18px 45px rgba(15, 23, 42, 0.08)',
        }}
      >
        <Stack spacing={2.25} alignItems="center" textAlign="center">
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'rgba(25, 118, 210, 0.08)',
              color: 'primary.main',
            }}
          >
            {stage === 'confirming' ? (
              <CircularProgress size={26} />
            ) : (
              <MarkEmailReadOutlinedIcon />
            )}
          </Box>

          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.75 }}>
              Подтверждение email
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {stage === 'confirming'
                ? 'Проверяем ссылку и подтверждаем вашу почту.'
                : 'Чтобы завершить регистрацию, перейдите по ссылке из письма.'}
            </Typography>
          </Box>

          {stage === 'noCode' && (
            <Alert severity="info" sx={{ width: '100%', textAlign: 'left' }}>
              Если письмо не пришло, проверьте папку спам или зарегистрируйтесь еще раз.
            </Alert>
          )}

          <Stack spacing={1.25} sx={{ width: '100%' }}>
            {stage === 'noCode' && (
              <Button variant="contained" fullWidth onClick={() => navigate('/register')}>
                Зарегистрироваться
              </Button>
            )}

            <Button
              variant={stage === 'confirming' ? 'outlined' : 'text'}
              fullWidth
              onClick={() => navigate('/login')}
            >
              Назад ко входу
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </LayoutNoAuth>
  );
}
